<script lang="ts">
  import ProductCard from '$components/product-card/product-card.svelte';
  import Skeleton from '$components/ui/skeleton.svelte';

  import { t } from '$lib/i18n';
  import { cn } from '$lib/utils';

  import type { ProductCardFragment } from '$gql/storefront/operations';

  export let products: ProductCardFragment[] | undefined = undefined;
  export let loading = false;
  export let seeAll = false;
  export let noResults: boolean | undefined = undefined;
  export let isRecentlyViewed = false;

  let className: string | undefined = undefined;
  export { className as class };
</script>

<div
  class={cn(
    'flex -mx-2 lg:mx-0 lg:grid lg:grid-cols-6 gap-2 overflow-x-auto hide-scrollbar lg:[&>*:first-child]:ml-0 [&>*:first-child]:ml-2 [&>*:last-child]:mr-2 lg:[&>*:last-child]:mr-0',
    !isRecentlyViewed && 'grid grid-cols-2 mx-0 [&>*:last-child]:mr-0 [&>*:first-child]:ml-0',
    className
  )}
>
  {#if loading}
    {#each Array(6) as _}
      <Skeleton class="aspect-[183/304] rounded-sm" />
    {/each}
  {:else if !!products?.length && !noResults}
    {#each products as product (product.handle)}
      {#if product}
        <ProductCard {product} variant="small" class="min-w-[140px] lg:min-w-[unset]" />
      {/if}
    {/each}
    {#if seeAll}
      <button
        type="submit"
        class="h-full bg-primary/4 rounded-sm grid place-items-center aspect-[183/304] min-w-[140px] lg:min-w-[unset]"
      >
        {$t('search.see-all')}
      </button>
    {/if}
  {:else if noResults}
    <p class="col-span-full lg:px-0 px-2">
      {$t('search.empty-state')}
    </p>
  {/if}
</div>
